import axios from 'axios'
import { call, put, select, takeEvery, takeLatest, delay } from 'redux-saga/effects'
import { PAM_API } from 'constants/url'
import { fromIdentity } from 'store/selectors'
import { toast } from 'react-toastify'
import intl from 'react-intl-universal'
import * as actions from './actions'

export function* getCategories() {
  yield delay(300)
  try {
    const ticket = yield select(fromIdentity.getTicket)

    const { data } = yield call(axios.get, `${PAM_API}/api/categories`, {
      headers: {
        authenticateit_identity_ticket: ticket
      }
    })

    yield put(actions.pamGetCategoriesSuccess(data))
  } catch (error) {
    yield put(actions.pamGetCategoriesFail(error))
  }
}

export function* updateCategory({ payload }) {
  try {
    const ticket = yield select(fromIdentity.getTicket)
    const category = { ...payload }

    const { data } = yield call(axios.patch, `${PAM_API}/api/categories`, category, {
      headers: {
        authenticateit_identity_ticket: ticket
      }
    })

    if (data.result === 'Category updated') {
      yield put(actions.pamUpdateCategorySuccess())
      toast.success(intl.get('alerts.updateCategorySuccess', { name: payload.name }))
      yield put(actions.pamGetCategories())
      return
    }

    toast.error(intl.get('alerts.updateCategoryFail'))
    yield put(actions.pamUpdateCategoryFail())
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      toast.error(`${error.response.data.error}`)
    } else {
      toast.error(intl.get('alerts.updateCategoryFail'))
    }

    yield put(actions.pamUpdateCategoryFail(error))
  }
}

export function* addCategory({ payload }) {
  try {
    const ticket = yield select(fromIdentity.getTicket)
    const category = { ...payload }
    delete category.keywords
    // category.keywords = category.keywords.join(',')
    const { data } = yield call(axios.post, `${PAM_API}/api/categories`, category, {
      headers: {
        authenticateit_identity_ticket: ticket
      }
    })

    if (data.result === 'Category added') {
      yield put(actions.pamAddCategorySuccess())
      toast.success(intl.get('alerts.addCategorySuccess', { name: payload.name }))
      yield put(actions.pamGetCategories())
      return
    }

    toast.error(intl.get('alerts.addCategoryFail'))
    yield put(actions.pamAddCategoryFail())
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      toast.error(`${error.response.data.error}`)
    } else {
      toast.error(intl.get('alerts.addCategoryFail'))
    }

    yield put(actions.pamAddCategoryFail(error))
  }
}

export function* deleteCategory({ payload }) {
  try {
    const ticket = yield select(fromIdentity.getTicket)

    const { data } = yield call(axios.delete, `${PAM_API}/api/categories`, {
      headers: {
        authenticateit_identity_ticket: ticket
      },
      data: {
        id: payload.id
      }
    })

    if (data.result === 'Category deleted') {
      yield put(actions.pamDeleteCategorySuccess())
      toast.success(intl.get('alerts.deleteCategorySuccess', { name: payload.name }))
      yield put(actions.pamGetCategories())
      return
    }

    toast.error(intl.get('alerts.deleteCategoryFail'))
    yield put(actions.pamDeleteCategoryFail())
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      toast.error(`${error.response.data.error}`)
    } else {
      toast.error(intl.get('alerts.deleteCategoryFail'))
    }

    yield put(actions.pamDeleteCategoryFail(error))
  }
}

export default function*() {
  yield takeLatest(actions.GET_CATEGORIES, getCategories)
  yield takeEvery(actions.UPDATE_CATEGORY, updateCategory)
  yield takeEvery(actions.ADD_CATEGORY, addCategory)
  yield takeEvery(actions.DELETE_CATEGORY, deleteCategory)
}
